import React, { useState, useEffect } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Table, Icon, Modal } from 'antd';
import DrawerPagamento from "./Drawers/DrawerPagamento";
import axios from "axios";
import moment from "moment";

const confirm = Modal.confirm;
const Tabela = ({ match }) => {
    const [visible, setVisible] = useState(false);
    const [dividaId, setDividaId] = useState();
    const [dividas, setDividas] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [loading, setLoading] = useState(false);

    const extensions = [".bmp", ".csv", ".odt", ".doc", ".docx", ".gif", ".htm", ".html", ".jpg", ".jpeg", ".pdf", ".png", ".ppt", ".pptx", ".tiff", ".txt", ".xls", ".xlsx"];

    const cols = [
        {
            title: "Descrição",
            dataIndex: "descricao"
        },
        {
            title: "Data",
            dataIndex: "data"
        },
        {
            title: "Tipo de Pagamento",
            dataIndex: "tipo"
        },
        {
            title: "Estado",
            dataIndex: "estado"
        },
        {
            title: "Valor",
            dataIndex: "valor"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    const carregar = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-dividas",
            params: {
                code: match.params.code
            }
        })
            .then(response => {
                var lista = response.data.map(divida => {
                    return {
                        descricao: divida.tipo,
                        data: moment(divida.data).format("DD/MM/YYYY"),
                        tipo: divida.pagamento,
                        estado: divida.pago ? <span className="state-green-tag">Pago</span> : <span className="state-red-tag">Pendente</span>,
                        valor: `R$ ${divida.valor}`,
                        opcoes: <div className="documentos-opcoes">
                            <Link className="botao-icon-editar" to="#" title="Editar" onClick={() => { setVisible(true); setDividaId(divida.id) }}>
                                <Icon type="edit" />
                            </Link>
                            <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluir(divida.id)}>
                                <Icon type="delete" />
                            </Link>
                        </div>
                    }
                })
                setDividas(lista);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    }

    const excluir = (dividaId) => {
        confirm({
            title: "Pretende excluir este registo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/user-detalhe/excluir-divida",
                    params: {
                        dividaId
                    }
                })
                    .then(response => {
                        carregar();
                    })
                    .catch(error => {

                    });
            }
        });
    }

    useEffect(() => {
        carregar();
    }, [])

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Table
                className="tabela-documentos tabela-aproveitamento"
                columns={cols}
                pagination={false}
                dataSource={dividas}
                loading={{
                    spinning: loading,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
            />
            <div className="opcoes-meus-cursos">
                <Link to="#" className="btn-adicionar" title="Adicionar" onClick={() => setVisible(true)}>
                    +
                </Link>
            </div>
            <DrawerPagamento
                extensions={extensions}
                dividaId={dividaId}
                visible={visible}
                onClose={() => setVisible(false)}
                atualizar={() => { carregar(); setVisible(false); }}
            />
        </>
    );
}

export default withRouter(Tabela);